export default "__VITE_ASSET__BVSMQbMD__"